import { useTranslation } from '@flecto/translations'

import { type OnboardingStep } from '../types/OnboardingStep'

export const useOnboardingStepsData = (): OnboardingStep[] => {
  const { t } = useTranslation('saas', { keyPrefix: 'onboarding' })

  return [
    {
      stepNumber: 1,
      key: 'onboarding_step_basic_info',
      title: t('steps.basic_info.title'),
      description: t('steps.basic_info.description'),
    },

    {
      stepNumber: 2,
      key: 'onboarding_step_main_location',
      title: t('steps.main_location.title'),
      description: t('steps.main_location.description'),
    },

    {
      stepNumber: 3,
      key: 'onboarding_step_business_info',
      title: t('steps.business_info.title'),
      description: t('steps.business_info.description'),
    },
  ]
}
